var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.64 7.646a.467.467 0 0 1 .68 0L14.5 12l-4.18 4.354a.467.467 0 0 1-.68 0 .515.515 0 0 1 0-.708L13.143 12 9.641 8.354a.515.515 0 0 1 0-.708Z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronRight;